import { useCallback } from 'react';

/**
 * Hook to manage absence-related API requests using apiCHAT.
 */
const useAusenciaApi = ({ apiCHAT, tokenChat }) => {
    // ─── Fetch Employee Post & Scale info ─────────────────────────────────────
    const fetchPessoaPostoLocalTrabalho = useCallback(async () => {
        if (!tokenChat) return null;
        const response = await apiCHAT.get('/postos-locais/pessoa', {
            headers: { Authorization: `Bearer ${tokenChat}` },
        });
        return response.data;
    }, [apiCHAT, tokenChat]);

    // ─── Confirm Absence (Save coverage post) ─────────────────────────────────
    const confirmarAusencia = useCallback(
        async (sessionId, payload) => {
            if (!tokenChat) return null;
            const response = await apiCHAT.post(`/cobertura-posto/chat_session?session_id=${sessionId}`, payload, {
                headers: { Authorization: `Bearer ${tokenChat}` },
            });
            return response.data;
        },
        [apiCHAT, tokenChat],
    );

    // ─── Fetch Detailed Absence Session ───────────────────────────────────────
    const fetchDetalhadoAusencia = useCallback(
        async (sessionId) => {
            if (!tokenChat) return null;
            const response = await apiCHAT.get(
                `/chatbot-sessao-cobertura-posto/view-detalhado?id_sessao_chat=${sessionId}`,
                {
                    headers: { Authorization: `Bearer ${tokenChat}` },
                },
            );
            return response.data;
        },
        [apiCHAT, tokenChat],
    );

    return {
        fetchPessoaPostoLocalTrabalho,
        confirmarAusencia,
        fetchDetalhadoAusencia,
    };
};

export default useAusenciaApi;
